import { Component } from '@angular/core';
import { TreeNode } from 'primeng/primeng';
import { isUndefined } from 'util';
import { RouterConst } from '../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { LocationGroup } from './location-group.model';
import { ClientsService } from '../../../services/clients/clients.service';
import { Globals } from '../../../globals/Globals';
import { SuperClass } from '../../../superclass/SuperClass';
import { WsService } from '../../../services/websocket/WsService';
import { DashboardDataService } from '../../../services/dashboard-data.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-location-groups',
  templateUrl: './location-groups.component.html',
  styleUrls: ['./location-groups.component.css'],
})
export class LocationGroupsComponent extends SuperClass {
  venuesForGroups: any;
  selectedVenues: any;

  display = false;

  newVenueGroupForm: FormGroup;
  selectedVenueGroupForm: FormGroup;

  venueGroups: any;
  currentVenueGroup;
  selectedVenueGroup;
  newVenueGroup;
  venueGroupsTree: TreeNode[];
  newParentVenueGroupId;
  newParentVenueGroupsTree: TreeNode[];

  parentVenueGroup: any;
  parentVenueGroupsTree: TreeNode[];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      {
        label: 'Location Groups',
        routerLink: [{ outlets: { sub: [RouterConst.LOCATION_GROUPS] } }],
      },
    ]);
    this.newVenueGroup = new LocationGroup();
  }

  reloadData() {
    this.http_getTreeInfo(
      {
        withLocations: false,
        getAll: true,
        withNoParent: false,
        excludeId: undefined,
      },
      (data: any) => {
        if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
          this.venueGroupsTree = JSON.parse(data.payload);
        }
      },
    );

    this.http_getVenueGroups((data: any) => {
      this.venueGroups = data.payload;
    });

    this.http_getVenuesForGroups((data: any) => {
      this.venuesForGroups = JSON.parse(data.payload);
    });

    this.selectedVenueGroupForm = this.fb.group({
      name: new FormControl('', Validators.required),
      lat: new FormControl('', Validators.pattern('[+-]?[0-9]+(\\.[0-9]+$)')),
      long: new FormControl('', Validators.pattern('[+-]?[0-9]+(\\.[0-9]+$)')),
      zoom: new FormControl(
        '',
        Validators.compose([
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
        ]),
      ),
    });

    this.newVenueGroupForm = this.fb.group({
      name: new FormControl('', Validators.required),
      lat: new FormControl('', Validators.pattern('[+-]?[0-9]+(\\.[0-9]+$)')),
      long: new FormControl('', Validators.pattern('[+-]?[0-9]+(\\.[0-9]+$)')),
      zoom: new FormControl(
        '',
        Validators.compose([
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
        ]),
      ),
    });
  }

  onVenueGroupSelect(e) {
    this.currentVenueGroup = this.venueGroups.filter(el => {
      return el.id === e.node.id;
    })[0];

    if (this.selectedVenueGroup) {
      this.http_getTreeInfo(
        {
          withLocations: false,
          getAll: true,
          withNoParent: true,
          excludeId: this.selectedVenueGroup.id,
        },
        (response: any) => {
          this.parentVenueGroupsTree = JSON.parse(response.payload);
          const parentGroupId = this.currentVenueGroup.parentGroupId;
          this.parentVenueGroup = this.venueGroups.filter(el => {
            return parentGroupId === el.id;
          })[0];
        },
      );

      const selectedVenues = [];
      const currentVenueGroup = this.currentVenueGroup;
      this.venuesForGroups.forEach(el => {
        if (currentVenueGroup.venueCodes.indexOf(el.data) !== -1) {
          selectedVenues.push(el);
        }
      });
      this.selectedVenues = selectedVenues;
    }
  }

  onParentVenueGroupSelect(e) {
    this.parentVenueGroup = this.venueGroups.filter(el => {
      return e.node.id === el.id;
    })[0];
  }

  onNewParentVenueGroupSelect(e) {
    this.newParentVenueGroupId = this.venueGroups.filter(el => {
      return e.node.id === el.id;
    })[0];
  }

  saveVG() {
    this.currentVenueGroup.parentGroupId = !isUndefined(this.parentVenueGroup)
      ? this.parentVenueGroup.id
      : undefined;
    if (!isUndefined(this.selectedVenues)) {
      const venueCodes = [];
      this.selectedVenues.forEach(function(el) {
        venueCodes.push(el.data);
      });
      this.currentVenueGroup.venueCodes = venueCodes;
    }

    const requiredFields = [
      {
        id: 'ilg_button',
        value: this.parentVenueGroup,
        fieldName: 'Parent Group Id',
      },
    ];
    if (this.hasEmptyFields(requiredFields)) {
      return;
    }

    const venueGroup = {
      venueGroupId: this.currentVenueGroup.venueGroupId,
      parentGroupId: this.currentVenueGroup.parentGroupId,
      lat: this.currentVenueGroup.lat,
      lng: this.currentVenueGroup.lng,
      zoomLevel: this.currentVenueGroup.zoomLevel,
      description: this.currentVenueGroup.description,
      venueCodes: this.currentVenueGroup.venueCodes,
    };
    this.http_updateVenueGroup(venueGroup, (data: any) => {
      this.venueGroupsTree = JSON.parse(data.payload);
      this.showSuccessMessage('Location Group has been updated');
      this.http_getVenueGroups((response: any) => {
        this.venueGroups = response.payload;
      });
    });
  }

  addVG() {
    this.http_getTreeInfo(
      {
        withLocations: false,
        getAll: true,
        withNoParent: true,
        excludeId: undefined,
      },
      (data: any) => {
        if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
          this.newParentVenueGroupsTree = JSON.parse(data.payload);
        }
      },
    );
    this.display = true;
    this.clean(this.newVenueGroup);
  }

  createVG() {
    const venueGroup = {
      parentGroupId: this.newParentVenueGroupId
        ? this.newParentVenueGroupId.id
        : undefined,
      lat: this.newVenueGroup.lat,
      lng: this.newVenueGroup.lng,
      zoomLevel: this.newVenueGroup.zoomLevel,
      description: this.newVenueGroup.description,
    };

    const requiredFields = [
      {
        id: 'nlg_button',
        value: venueGroup.parentGroupId,
        fieldName: 'Parent Group',
      },
    ];
    if (this.hasEmptyFields(requiredFields)) {
      return;
    }

    this.http_createNewVenueGroup(venueGroup, (data: any) => {
      this.venueGroupsTree = JSON.parse(data.payload);
      this.showSuccessMessage('New Location Group has been created');
      this.http_getVenueGroups((response: any) => {
        this.venueGroups = response.payload;
      });
    });
    this.display = false;
  }

  deleteVG() {
    this.http_deleteVenueGroup(
      { id: this.selectedVenueGroup.id },
      (data: any) => {
        this.venueGroupsTree = JSON.parse(data.payload);
        this.selectedVenueGroup = this.venueGroupsTree[0];
        this.showSuccessMessage('New Location Group has been deleted');
        this.currentVenueGroup.description = 'Select a Group';
        this.selectedVenueGroup = undefined;
        this.http_getVenueGroups((response: any) => {
          this.venueGroups = response.payload;
        });
      },
    );
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  // TODO: make helper service with clean function
  clean(obj) {
    Object.keys(obj).forEach(prop => {
      console.log('PROP', obj[prop]);
      obj[prop] = null;
    });
    this.newParentVenueGroupId = null;
  }

  unselectRow() {}
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/location-groups/location-groups.component.ts